var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-08-28
 * @brief SEI 모니터링 캘린더 개발
 *
 ********************************************************************/
import { useState } from "react";
//calendar module
import { Badge, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { PickersDay, StaticDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider, pickersLayoutClasses } from "@mui/x-date-pickers/";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { getApiLangState } from "../../../../recoil/langState";
import { reloadToady } from "../../../../recoil/userState";
import * as CONST from "../../../../utils/Const";
function CalendarView(props) {
    //recoil
    const apiLang = useRecoilValue(getApiLangState);
    const setReloadToady = useSetRecoilState(reloadToady);
    // props
    const { highlightedDays, today, setToday, setMonth } = props;
    const locales = ["ko", "en"];
    // 언어설정
    const [locale, setLocale] = useState(apiLang == CONST.STR_APILANG_KOR ? "ko" : "en");
    // 일자 관련 커스텀
    function ServerDay(props) {
        const { highlightedDays = [], day, outsideCurrentMonth } = props, other = __rest(props, ["highlightedDays", "day", "outsideCurrentMonth"]);
        const isSelected = (highlightedDays === null || highlightedDays === void 0 ? void 0 : highlightedDays.find((days) => days.date === dayjs(props.day).format("YYYY-MM-DD"))) || null;
        const isColoer = props.day.toDate().toDateString() === new Date().toDateString();
        return (_jsxs(Badge, Object.assign({ sx: {
                height: "40px",
                width: "43px",
            } }, { children: [isSelected ? (_jsxs("ul", Object.assign({ className: "todo-dot" }, { children: [isSelected.ech > 0 ? (_jsx("li", Object.assign({ className: "ech" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "e-HC" })) }))) : null, isSelected.job > 0 ? (_jsx("li", Object.assign({ className: "job" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC9C1\uBB34\uACE0\uC2DC" })) }))) : null, isSelected.etc > 0 ? (_jsx("li", Object.assign({ className: "etc" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uAE30\uD0C0" })) }))) : null, isSelected.memo > 0 ? (_jsx("li", Object.assign({ className: "memo" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uBA54\uBAA8" })) }))) : null] }))) : null, _jsx(PickersDay, Object.assign({}, other, { outsideCurrentMonth: outsideCurrentMonth, day: day, style: {
                        color: isColoer ? "blue" : "",
                        fontWeight: "200px",
                    } }))] }), props.day.toString()));
    }
    function ActionList(props) {
        const { onSetToday, className } = props;
        const actions = [{ text: "Today", method: onSetToday }];
        return (
        // Propagate the className such that CSS selectors can be applied
        _jsx(List, Object.assign({ className: className }, { children: actions.map(({ text, method }) => (_jsx(ListItem, Object.assign({ disablePadding: true }, { children: _jsx(ListItemButton, Object.assign({ onClick: method }, { children: _jsx(ListItemText, { primary: text }) })) }), text))) })));
    }
    const minYearDate = dayjs(new Date()).set("year", dayjs(new Date()).year() - 10); // minmum 기준 10년
    const maxYearDate = dayjs(new Date()).set("year", dayjs(new Date()).year() + 1); // maxmum 기준 5년
    function onChangeDate(date, dailys) {
        if (dailys == "day") {
            setToday(dayjs(date));
            setReloadToady(true);
        }
        else {
            setMonth(dayjs(date).format("YYYYMM"));
        }
    }
    return (_jsx(_Fragment, { children: _jsx(LocalizationProvider, Object.assign({ dateAdapter: AdapterDayjs, adapterLocale: locale, dateFormats: { fullDate: "YYYY년MM월DD일" } }, { children: _jsx(StaticDatePicker, { value: today, onChange: (date) => onChangeDate(date, "day"), maxDate: maxYearDate, minDate: minYearDate, onMonthChange: (date) => onChangeDate(date, "month"), dayOfWeekFormatter: (week) => week, 
                // `${console.log("week",week)}`
                // views={}
                slots: {
                    day: ServerDay,
                    actionBar: ActionList,
                }, slotProps: {
                    toolbar: { hidden: true },
                    actionBar: {
                        actions: ["today"],
                    },
                    day: {
                        highlightedDays,
                    },
                    layout: {
                        sx: {
                            [`.${pickersLayoutClasses.actionBar}`]: {
                                gridColumn: 2,
                                gridRow: 2,
                                width: "50%",
                                height: "10%",
                                left: "30%",
                                color: "#1976d2",
                            },
                        },
                    },
                } }) })) }));
}
export default CalendarView;
